// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"3329e8a2","61":"827b805b","77":"82fb574a","97":"239b46f1","134":"c5259d54","357":"1a40ddf2","414":"f7ac1a02","429":"afd421d4","453":"53ef8a8f","573":"24e8befc","608":"3d45820e","657":"33163949","863":"83c8bcab"}[chunkId] + ".chunk.js";
};